import { ApiHandler } from '@eshop/api-client'

import i18n from './i18n'

import { ServiceProduct } from '#/global/service/Product'

import { Config } from '#/global/helper/Config'
import { MessageFlash } from '#/global/helper/MessageFlash'

import type { AddToCartRental, AddToCartRentalAfter } from '#/global/types'

/**
 * @todo přesunout do @eshop/api-client
 */
interface ApiErrorList {
    errors: {
        code: string
        message: string
        path: string
    }[]
}

const formatDate = (date: Date) => `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`

const addToCartRental = (event: CustomEvent<AddToCartRental>) => {
    const detail = event.detail

    detail.quantitySales ??= detail.quantity
    detail.quantity ??= detail.quantitySales

    const payload = {
        unionCode: detail.unionCode,
        quantity: detail.quantitySales,
        // ! HOTFIX! když to jde na ISO tak se to převede a je to -2hodiny -> posouvá o den zpět
        // dateFrom: detail.dateFrom.toISOString().split('T')[0],
        // dateTo: detail.dateTo.toISOString().split('T')[0],
        dateFrom: formatDate(detail.dateFrom),
        dateTo: formatDate(detail.dateTo),
        typeOfRental: detail.typeOfRental,
        withGuarantee: detail.withGuarantee ?? false,
    }

    const api = new ApiHandler({
        path: '/cart/add-to-cart-rental',
        method: 'POST',
        body: payload,
    })

    api
        .addResponseHandler('2xx', async () => {
            const data = await api.getData()
            const recordId = data?.recordId

            const product = await ServiceProduct.getProductRentalByCode(detail.unionCode, ['detail', 'price', 'related'])
            if (product[0] === null) {
                return
            }

            window.dispatchEvent(new CustomEvent<AddToCartRentalAfter>('ES_ADD_TO_CART_RENTAL_AFTER', { detail: {
                ...detail,
                isSuccess: true,
                recordId,
                product: product[0],
            } }))
        })
        .addResponseHandler('4xx', async (response) => {
            const body = await api.getData<ApiErrorList>(true)
            const t = i18n[Config.getLang()]

            if (response.status === 400 && body?.errors.some(error => error.code === '1')) {
                MessageFlash.addError(t.rental.ban)
                return
            }

            await api.handleError()
        })

    api.send().catch((error) => {
        console.error('[GlobalListener-AddToCartRental]:', error)
    })
}

export default addToCartRental
